import { bindable, BindingMode, inject } from 'aurelia';

@inject(Element)

export class InputTextareaCustomElement {
  @bindable({ mode: BindingMode.twoWay }) value;
  @bindable r;
  @bindable l = 200;
  @bindable pH;
  @bindable counter;
  @bindable tI;
  @bindable helpText;
  @bindable helpTextPosition = "right";
  @bindable helpTextTrigger ="focus";
  @bindable showMax = false;

  constructor(element) {
    this.element = element;
  }

  attached() {
    if (!this.pH) this.placeholder = '';
    if (!this.tI) this.textarea.removeAttribute("tabindex"); //remove attribute to let browser handle tab order    
    if (!this.pH) this.pH = this.getPlaceholder();
    if (this.counter == null) this.counter = true; 
    if (this.counter === 'false') this.counter = false; 
    
    // this.element.addEventListener("focus", () => { 
    //   this.textarea.focus();
    //  });
  }

  getPlaceholder() {
    const projected = [...this.label.childNodes].find(
      (node) => node.nodeType === Node.TEXT_NODE && node.wholeText.trim() !== ""
    );
    return "Ange " + (projected?.wholeText.trim() ?? "").toLowerCase();
  }

  addErrorClass() {
    this.textarea.classList.add("has-error");
    
  }

  removeErrorClass() {
    this.textarea.classList.remove("has-error");
  }
}


